import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ImageMask } from 'elements/visual/ImageMask';
import { EColors, EFonts, EGrads } from 'libs/styles/styling';
import styled, { css } from 'styled-components/macro';

interface Props {
    icon?: {
        iconName: IconName;
        iconSet: IconPrefix;
    };
    text: string;
    onClick?: () => void;
    selected?: boolean;
    className?: string;
}

export const ToolSelectionButton = (props: Props): JSX.Element => {
    return (
        <S_ToolSelectionButton
            className={props.className}
            onClick={() => {
                if (!props.selected) {
                    props.onClick?.();
                }
            }}
            $selected={props.selected}
        >
            {props.icon && (
                <S_Icon
                    $selected={props.selected}
                    icon={[props.icon.iconSet, props.icon.iconName]}
                />
            )}
            <S_Text $selected={props.selected}>{props.text}</S_Text>
            {props.selected && (
                <ImageMask randomizePosition={true} step={20} image="contour" repeat={true} />
            )}
        </S_ToolSelectionButton>
    );
};

const S_ToolSelectionButton = styled.div<{ $selected: boolean }>`
    display: flex;
    position: relative;
    flex-direction: column;
    user-select: none;
    width: 70px;
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 7px;
    border: 1px solid ${EColors.GREY5};
    position: relative;
    overflow: hidden;
    ${(props) => {
        if (props.$selected) {
            return css`
                background: ${EGrads.ACC2_GRAD};
            `;
        } else {
            return css`
                cursor: pointer;
                background: linear-gradient(180deg, #eee 0%, #fff 100%);
                box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
            `;
        }
    }}
`;

const S_Icon = styled(FontAwesomeIcon)<{ $selected: boolean }>`
    font-size: 20px;
    color: ${(props) => (props.$selected ? '#fff' : '#141c54')};
    margin-bottom: 7px;
`;

const S_Text = styled.div<{ $selected: boolean }>`
    font-size: 13px;
    font-family: ${EFonts.Regular};
    color: ${(props) => (props.$selected ? '#fff' : '#141c54')};
    width: 100%;
    text-align: center;
`;
